export default __webpack_public_path__ + "static/architect-default-image-b93f97dc7030824ec8587b89d4446e29.jpg";